import { Component, DestroyRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { loadLatestNotifications } from 'src/app/core/actions/auth.actions';
import {
  selectAuthUserNotifications,
  selectAuthUserNotificationsLoaded,
  selectAuthUserNotificationsLoading,
} from 'src/app/core/reducers';
import { AppState } from 'src/app/reducers';

import { Notification } from 'src/app/core/models/core.models';

import { Observable, take, tap } from 'rxjs';

@Component({
    selector: 'app-dropdown-notifications',
    templateUrl: './dropdown-notifications.component.html',
    styleUrls: ['./dropdown-notifications.component.scss'],
    standalone: false
})
export class DropdownNotificationsComponent {
  @Input() closeMethod!: () => void;

  notifications$: Observable<Notification[]>;
  notificationsLoading$: Observable<boolean>;

  private destroyRef = inject(DestroyRef);

  notificationCount: number;

  constructor(private store: Store<AppState>) {
    this.store
      .select(selectAuthUserNotificationsLoaded)
      .pipe(
        take(1),
        tap((loaded) => {
          if (!loaded) {
            this.store.dispatch(loadLatestNotifications());
          }
        }),
      )
      .subscribe();

    this.notifications$ = this.store.select(selectAuthUserNotifications);
    this.notificationsLoading$ = this.store.select(
      selectAuthUserNotificationsLoading,
    );

    this.notifications$
      .pipe(
        tap((notifications) => {
          this.notificationCount = notifications.length;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  ngOnInit() {}

  trackByNotificationId(index: number, item: Notification): string | number {
    return item.fingerprint_id;
  }
}
